// extracted by mini-css-extract-plugin
export default {"info":"Info_info__vPL4x","infoContent":"Info_infoContent__PKxga"};